import { render, staticRenderFns } from "./main-header-search.vue?vue&type=template&id=741e92e6&"
import script from "./main-header-search.vue?vue&type=script&lang=js&"
export * from "./main-header-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports